const state = {
  menu: [],
  asyncRouters: []
};

const mutations = {
  SET_MENU: (state, data) => {
    state.menu = data;
  },
  RESET_MENU: state => {
    state.menu = [];
  },
  SET_ASYNCROUTERS: (state, data) => {
    state.asyncRouters = data;
  },
  RESET_ASYNCROUTERS: state => {
    state.asyncRouters = [];
  }
};
const actions = {
  setMenu({ commit }, data) {
    commit("SET_MENU", data);
  },
  resetMenu({ commit }) {
    commit("RESET_MENU");
  },
  setAsyncRouters({ commit }, data) {
    commit("SET_ASYNCROUTERS", data);
  },
  resetMenuAllData({ commit }) {
    commit("RESET_MENU");
    commit("RESET_ASYNCROUTERS");
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
